export const items = [
  {
    name: "Private 1hr Crypto, Blockchain, NFT Class",
    price: 150,
    about:
      "Vestibulum vehicula velit vitae libero maximus posuere vitae nec sem. Ut at enim nisi. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam malesuada lacus sit amet lorem lacinia, a finibus erat lobortis. Fusce mollis metus nunc, iaculis malesuada urna blandit rhoncus. Nulla luctus eu ex et faucibus.",
  },
  {
    name: "Private 1hr NFT Flipping and Sniping class",
    price: 150,
    about:
      "NFT flipping was in 2021 the most profitable activity you could have done. NFT flippers made more than Fortune500 CEOs. The NFT game is about understanding risk and understanding short term market moves. Knowing how to mint, flip, get whitelisted and take profits in a systematic way. Want to learn how to do all of these things? Want to learn how to use the necessary tools to be able to make big profits? I’m here to guide you. ",
  },
];
